
if (successMessage) {
    swal("¡Éxito!", "El mensaje se ha enviado correctamente.", "success");
} else if (errorMessage) {
    swal("¡Error!", "Hubo un problema al enviar el mensaje.", "error");
}

window.CrearContacto = (form) => {
    if (form == null) {
        return;
    }
    let btnSubmit = form.querySelector(".btn-submit")
    form.addEventListener("submit", (e) => {
        e.preventDefault()
        btnSubmit.disabled = true
        axios
            .post('/contacto', new FormData(form))
            .then((respuesta) => {
                btnSubmit.disabled = false
                if (respuesta.data.error) {
                    Alerta(respuesta.data.error, "info");
                } else {
                    form.reset();
                    Alerta(respuesta.data.mensaje, "success");
                }
            })
            .catch((error) => {
                console.log(error)
                btnSubmit.disabled = false
                Alerta("Ocurrió un error inesperado", "info");
            })

    });
}
